import Role from '@/page/system/maintain/Role';
import Operater from '@/page/system/user/Operater';
import Cashier from '@/page/system/user/cashier';
import Shopkeeper from '@/page/system/user/Shopkeeper';
import Head from '@/page/system/user/Head';
import Binding from '@/page/system/user/Binding';
import Buy from '@/page/system/user/Buy';
import Merchants from '@/page/system/maintain/Merchants';
import Log from '@/page/system/maintain/Log';
import Data from '@/page/system/maintain/Data';
import Agreement from '@/page/system/maintain/Agreement';
import Setting from '@/page/system/maintain/Setting';
import RapDetail from '@/page/system/maintain/rap/Detail';
import Summary from '@/page/system/maintain/rap/Summary';
import Mgmt from '@/page/system/renewal/Mgmt';
import Interface from '@/page/system/pay/Interface';
import Way from '@/page/system/pay/Way';
import Notice from '@/page/system/Notice';
import UpgradePwd from '@/page/system/user/UpgradePwd';
import Detail from '@/components/template/detail'
import Img from '@/page/system/maintain/Img';
import Auth from "@/page/system/applet/Auth";
import ApSetting from '@/page/system/applet/Setting';
import WeAuth from '@/page/system/wechat/Auth';
import Menu from '@/page/system/wechat/menu';
import Template from '@/page/system/wechat/Template';
import MgmtOther from '@/page/system/user/other/Mgmt';
import liveList from '@/page/system/applet/live/liveList';
import liveAdd from '@/page/system/applet/live/liveAdd';
import liveGoods from '@/page/system/applet/live/liveGoods';
import Members from '@/page/system/applet/live/members';
import staff from "../page/system/user/staff";//新用户管理
import nowRole from "../page/system/maintain/nowRole";//新角色管理
export const system = [{
  path: '/system/maintain/role',
  name: 'role',
  component: Role,
  meta: {
    requireAuth: true,
    title: '角色管理'
  },
},
  {
    path: '/system/user/mgmt',
    name: 'mgmt',
    component: Mgmt,
    meta: {
      requireAuth: true,
      title: '用户管理'
    }
  },
  {
    path: '/system/user/other/mgmt',
    name: 'mgmtOther',
    component: MgmtOther,
    meta: {
      requireAuth: true,
      title: '其他员工'
    }
  },
  {
    path: '/system/user/shopkeeper',
    name: 'shopkeeper',
    component: Shopkeeper,
    meta: {
      requireAuth: true,
      title: '店长'
    }
  },
  {
    path: '/system/user/shopkeeper/detail',
    name: 'shopkeeperDetail',
    component: Detail,
    meta: {
      requireAuth: true,
      title: '店长'
    }
  },
  {
    path: '/system/user/cashier',
    name: 'shopkeeper',
    component: Cashier,
    meta: {
      requireAuth: true,
      title: '收银员'
    }
  },
  {
    path: '/system/user/operater',
    name: 'operater',
        component: Operater,
        meta: {
            requireAuth: true,
            title: '操作员'
        }
    },
    {
        path: '/system/user/head',
        name: 'head',
        component: Head,
        meta: {
            requireAuth: true,
            title: '头像设置'
        }
    },
    {
        path: '/system/user/binding',
        name: 'binding',
        component: Binding,
        meta: {
            requireAuth: true,
            title: '账号绑定'
        }
    },
    {
        path: '/system/user/buy',
        name: 'buy',
        component: Buy,
        meta: {
            requireAuth: true,
            title: '购买记录'
        }
    },
    {
        path: '/system/maintain/merchants',
        name: 'merchants',
        component: Merchants,
        meta: {
            requireAuth: true,
            title: '商户资料'
        }
    },
    {
        path: '/system/maintain/log',
        name: 'log',
        component: Log,
        meta: {
            requireAuth: true,
            title: '系统日志'
        }
    },
    {
        path: '/system/maintain/data',
        name: 'data',
        component: Data,
        meta: {
            requireAuth: true,
            title: '清理业务数据'
        }
    },
    {
        path: '/system/maintain/agreement',
        name: 'agreement',
        component: Agreement,
        meta: {
            requireAuth: true,
            title: '店播.嘉维斯业务数据清理协议'
        }
    },
    {
        path: '/system/maintain/setting',
        name: 'setting',
        component: Setting,
        meta: {
            requireAuth: true,
            title: '系统设置'
        }
    },
    {
        path: '/system/maintain/rap/detail',
        name: 'detail',
        component: RapDetail,
        meta: {
            requireAuth: true,
            title: '加价明细'
        }
    },
    {
        path: '/system/maintain/rap/summary',
        name: 'summary',
        component: Summary,
        meta: {
            requireAuth: true,
            title: '加价汇总'
        }
    },
    {
        path: '/system/renewal/mgmt',
        name: 'mgmt',
        component: Mgmt,
        meta: {
            requireAuth: true,
            title: '续费管理'
        }
    },
    {
        path: '/system/pay/interface',
        name: 'interface',
        component: Interface,
        meta: {
            requireAuth: true,
            title: '支付接口'
        }
    },
    {
        path: '/system/pay/way',
        name: 'way',
        component: Way,
        meta: {
            requireAuth: true,
            title: '付款方式'
        }
    },
    {
        path: '/system/maintain/message',
        name: 'notice',
        component: Notice,
        meta: {
            requireAuth: true,
            title: '系统消息'
        }
    },
    {
        path: '/system/user/password',
        name: 'upgradePwd',
        component: UpgradePwd,
        meta: {
            requireAuth: true,
            title: '修改密码'
        }
    },
    {
        path: '/system/maintain/img',
        name: 'img',
        component: Img,
        meta: {
            requireAuth: true,
            title: '图片管理'
        }
    },
    {
        path: '/system/applet/auth',
        name: 'auth',
        component: Auth,
        meta: {
            requireAuth: true,
            title: '小程序授权'
        }
    },
    {
        path: '/system/applet/setting',
        name: 'setting',
        component: ApSetting,
        meta: {
            requireAuth: true,
            title: '小程序设置'
        }
    },
    {
        path: '/system/wechat/auth',
        name: 'weAuth',
        component: WeAuth,
        meta: {
            requireAuth: true,
            title: '公众号授权'
        }
    },
    {
        path: '/system/wechat/menu',
        name: 'menu',
        component: Menu,
        meta: {
            requireAuth: true,
            title: '自定义菜单'
        }
    },
    {
        path: '/system/wechat/template',
        name: 'template',
        component: Template,
        meta: {
            requireAuth: true,
            title: '公众号模版'
        }
    },
  {
    path: '/mall/live/room',
    name: 'liveList',
    component: liveList,
    meta: {
      requireAuth: true,
      title: '直播间列表'
    }
  },
  {
    path: '/mall/live/roomAdd',
    name: 'liveAdd',
    component: liveAdd,
    meta: {
      requireAuth: true,
      title: '创建直播间'
    }
  },
  {
    path: '/mall/live/goods',
    name: 'liveGoods',
    component: liveGoods,
    meta: {
      requireAuth: true,
      title: '直播商品入库'
    }
  },
  {
    path: '/mall/live/role',
    name: 'Members',
    component: Members,
    meta: {
      requireAuth: true,
      title: '直播成员管理'
    }
  },
  {
    path: '/system/user/staff',
    name: 'staff',
    component: staff,
    meta: {
      requireAuth: true,
      title: '员工管理'
    }
  },
  {
    path: '/system/maintain/now/role',
    name: 'nowRole',
    component: nowRole,
    meta: {
      requireAuth: true,
      title: '角色管理'
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/system.route.js